import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=4ebf113b&scoped=true&"
import script from "./step6.vue?vue&type=script&lang=js&"
export * from "./step6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf113b",
  null
  
)

export default component.exports